import { render, staticRenderFns } from "./DeleteItem.vue?vue&type=template&id=68ffe920&"
import script from "./DeleteItem.vue?vue&type=script&lang=js&"
export * from "./DeleteItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports